import React from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/button';

import { RootState } from '../../reducers';
import { unscheduleDeleteAccount } from './authThunks';
import { removeToken } from '../../lib/localStorageHandler';
import { getInitialState } from '../app/appSlice';
import { setAlertMessage } from '../dashboard/dashboardSlice';

const AccountDeletingCover = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const deleteRequestedAt = useSelector(
    (state: RootState) => state.settings.user.deleteRequestedAt,
  );

  const deleteRequestedMoment = moment(deleteRequestedAt);
  const deletionDate = moment(deleteRequestedMoment).add(14, 'days');
  const currentDate = moment();
  const daysRemaining = deletionDate.diff(currentDate, 'days');

  const handleProceed = async () => {
    await dispatch(unscheduleDeleteAccount());
    await dispatch(getInitialState());
    dispatch(
      setAlertMessage({
        type: 'success',
        message: t('auth.accountDeletion.restored'),
      }),
    );
  };

  const handleCancel = () => {
    removeToken();
    // Force reload, and go to home page
    window.location.href = '/';
  };

  return (
    <div className="flex justify-center items-center h-[98vh] bg-background">
      <div className="p-8 rounded-2xl bg-card border border-secondary flex flex-col items-center justify-center w-full max-w-[400px] text-left">
        <h1 className="text-2xl font-bold mb-4">
          {t('auth.accountDeletion.title')}
        </h1>
        <div className="w-80 text-left mb-6">
          <p className="mb-6">
            {t('auth.accountDeletion.daysRemaining', { days: daysRemaining })}
          </p>
          <p className="text-sm text-muted-foreground mb-6">
            {t('auth.accountDeletion.dataRemoval', { days: daysRemaining })}
          </p>
          <p className="text-sm text-muted-foreground mb-6">
            {t('auth.accountDeletion.cancellation')}
          </p>
        </div>
        <div className="mb-4 w-80">
          <Button
            id="proceed-to-signin-button"
            variant="default"
            className="w-full py-6"
            onClick={handleProceed}
          >
            {t('auth.accountDeletion.proceed')}
          </Button>
        </div>
        <div className="mb-4 w-80">
          <Button
            id="cancel-button"
            variant="ghost"
            className="w-full py-6"
            onClick={handleCancel}
          >
            {t('auth.accountDeletion.cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletingCover;
